import { withRouter } from 'react-router-dom';

import WarningModal from './WarningModal';

export default withRouter(WarningModal);
